<script>import { setContext } from "svelte";
import { writable } from "svelte/store";
import { getDefaultRegisteredComponents } from "../../constants/builder-registered-components";
import { TARGET } from "../../constants/target";
import ComponentsContext from "../../context/components.context";
import { serializeComponentInfo } from "../../functions/register-component";
import Blocks from "../blocks/blocks.svelte";
import { getUpdateVariantVisibilityScript } from "../content-variants/helpers";
import "../dynamic-div.svelte";
import InlinedScript from "../inlined-script.svelte";
import EnableEditor from "./components/enable-editor.svelte";
import ContentStyles from "./components/styles.svelte";
import { getContentInitialValue, getRootStateInitialValue, } from "./content.helpers";
import "./wrap-component-ref";
export let content = undefined;
export let customComponents = undefined;
export let data = undefined;
export let locale = undefined;
export let context = undefined;
export let canTrack = undefined;
export let apiKey;
export let apiVersion = undefined;
export let blocksWrapper = undefined;
export let blocksWrapperProps = undefined;
export let nonce = undefined;
export let model = undefined;
export let enrich = undefined;
export let showContent;
export let contentWrapper = undefined;
export let contentWrapperProps = undefined;
export let trustedHosts = undefined;
export let isSsrAbTest;
export let isNestedRender = undefined;
export let linkComponent = undefined;
function contentSetState(newRootState) {
    $builderContextSignal.rootState = newRootState;
}
let scriptStr = getUpdateVariantVisibilityScript({
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
    variationId: content?.testVariationId,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
    contentId: content?.id,
});
let registeredComponents = [
    ...getDefaultRegisteredComponents(),
    ...(customComponents || []),
].reduce((acc, { component, ...info }) => ({
    ...acc,
    [info.name]: {
        component: component,
        ...serializeComponentInfo(info),
    },
}), {});
let builderContextSignal = writable({
    content: getContentInitialValue({
        content: content,
        data: data,
    }),
    localState: undefined,
    rootState: getRootStateInitialValue({
        content: content,
        data: data,
        locale: locale,
    }),
    rootSetState: contentSetState,
    context: context || {},
    canTrack: canTrack,
    apiKey: apiKey,
    apiVersion: apiVersion,
    componentInfos: [
        ...getDefaultRegisteredComponents(),
        ...(customComponents || []),
    ].reduce((acc, { component: _, ...info }) => ({
        ...acc,
        [info.name]: serializeComponentInfo(info),
    }), {}),
    inheritedStyles: {},
    BlocksWrapper: blocksWrapper || "div",
    BlocksWrapperProps: blocksWrapperProps || {},
    nonce: nonce || "",
});
setContext(ComponentsContext.key, {
    registeredComponents: registeredComponents,
});
</script>

<EnableEditor
  {nonce}
  {content}
  {data}
  {model}
  {context}
  {apiKey}
  {canTrack}
  {locale}
  {enrich}
  {showContent}
  {builderContextSignal}
  {contentWrapper}
  {contentWrapperProps}
  {trustedHosts}
  {...{}}
>
  {#if isSsrAbTest}
    <InlinedScript
      id="builderio-variant-visibility"
      {scriptStr}
      nonce={nonce || ""}
    />
  {/if}
  {#if TARGET !== "reactNative"}
    <ContentStyles
      nonce={nonce || ""}
      {isNestedRender}
      contentId={$builderContextSignal.content?.id}
      cssCode={$builderContextSignal.content?.data?.cssCode}
      customFonts={$builderContextSignal.content?.data?.customFonts}
    />
  {/if}<Blocks
    blocks={$builderContextSignal.content?.data?.blocks}
    context={builderContextSignal}
    {registeredComponents}
    {linkComponent}
  /></EnableEditor
>